import script from "./VideoConference.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoConference.vue?vue&type=script&setup=true&lang=js"

import "./VideoConference.vue?vue&type=style&index=0&id=17347684&lang=scss"

const __exports__ = script;

export default __exports__